import {
  getAcceleratorOptions,
  getInstanceTypeOptions,
} from '@/features/evaluation/api/performanceMetricsApi';
import { DEPLOYMENT_INFRA_CATALOG } from './deploymentInfraCatalog';
import { createSelectedTask } from './taskRuntimeDefaults';

function firstOrNull(arr) {
  return Array.isArray(arr) && arr.length ? arr[0] : null;
}

function pickFirstInstance(catalog, cloud, hardware, accelerator) {
  const opts = getInstanceTypeOptions(cloud, hardware, accelerator, catalog);
  return firstOrNull(opts);
}

/** First cloud / hardware / accelerator / instance in the catalog (GPU before CPU). */
export function pickFirstInfraSelection(catalog = DEPLOYMENT_INFRA_CATALOG) {
  const cloud = firstOrNull(Object.keys(catalog || {}));
  if (!cloud) return null;
  const hardware = firstOrNull(Object.keys(catalog[cloud] || {}));
  if (!hardware) return null;
  const accelerators = getAcceleratorOptions(cloud, hardware, catalog);
  const accelerator = accelerators[0]?.value ?? null;
  const instance = pickFirstInstance(catalog, cloud, hardware, accelerator);
  return { cloud, hardware, accelerator, instance };
}

function resolveInfraSeed(training, usecase, catalog) {
  const preferredConfig =
    usecase?.preferred_deployment_config ||
    training?.usecase_preferred_deployment_config ||
    null;

  if (preferredConfig?.cloud_provider && preferredConfig?.instance_type) {
    return {
      cloud: preferredConfig.cloud_provider,
      hardware: preferredConfig.hardware_device,
      accelerator: preferredConfig.accelerator ?? null,
      instance: {
        value: preferredConfig.instance_type,
        label: preferredConfig.instance_type,
      },
      preferredInfrastructure: true,
    };
  }

  const seed = pickFirstInfraSelection(catalog);
  return {
    cloud: seed?.cloud ?? null,
    hardware: seed?.hardware ?? null,
    accelerator: seed?.accelerator ?? null,
    instance: seed?.instance ?? null,
    preferredInfrastructure: false,
  };
}

/**
 * Payload shape expected by {@link submitConfigureDeployment} for a single-task
 * deploy — mirrors Configure Deployment modal defaults (infra + runtime knobs).
 */
export function buildDefaultDeployPayload(
  training,
  usecase = null,
  catalog = DEPLOYMENT_INFRA_CATALOG
) {
  const infra = resolveInfraSeed(training, usecase, catalog);
  const selectedTask = createSelectedTask(training, usecase);

  const hardwareDevice = infra.hardware;
  const sharedConfig = {
    cloud_provider: infra.cloud,
    hardware_device: hardwareDevice,
    accelerator: infra.accelerator || null,
    instance_type: infra.instance?.value ?? null,
    device: (hardwareDevice || '').toLowerCase() === 'cpu' ? 'cpu' : 'gpu',
    preferred_infrastructure: infra.preferredInfrastructure,
  };

  return {
    mode: 'deploy',
    sharedConfig,
    tasks: [
      {
        training,
        config: { ...selectedTask.runtimeConfig },
      },
    ],
  };
}
